<footer class="footer-custom">
    <div class="container">
        <div class="row">

            <div class="col-md-6 left-column">
                <div class="logo-wrapper d-flex align-items-center">

                    <img src="/assets/images/logo-branco.png" />
                </div>
                <div class="contact-info">
                    <p>Feira do Livro é uma plataforma da Editora Diálogo Freiriano</p>
                    <p>Rua Benjamin Constant, 579, EDITORA Centro, Veranópolis - RS, CEP 95330-000</p>
                    <p>Chama no Whatsapp: (54) 92001-5501</p>
                    <p>E-mail: {{'contato@feiradolivro.com.br'}}</p>
                </div>
            </div>

            <div class="col-md-6 right-column d-flex flex-column align-items-md-end">
                <a href="#" class="back-to-top">
                    <svg class="arrow-icon" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="19" cy="19" r="18" stroke="white" stroke-width="2" />
                        <path d="M19 25V13M19 13L13 19M19 13L25 19" stroke="white" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Retornar ao topo
                </a>
                <div class="social-icons mt-md-4">
                    <a href="https://wa.me/5554920015501" aria-label="Whatsapp" target="_blank"><img
                            src="/assets/images/whatsapp.png"></a>
                    <a href="https://www.instagram.com/feiradolivro.com.br" aria-label="Instagram" target="_blank"><img
                            src="/assets/images/instagram.png"></a>
                    <a href="https://www.youtube.com/watch?v=Fh-naGDhrAo&list=PL64hs707P7eDnBLiqQCnycKk1WDqlDaOU"
                        target="_blank" aria-label="Instagram"><img style="height: 25px;"
                            src="/assets/images/youtube-logo.webp"></a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center copyright">
                Copyright © Feira do Livro - Todos os direitos reservados. CNPJ: 62.452.343/0001-44
            </div>
        </div>
    </div>
</footer>